import { createRequest, RequestConfig } from 'app/common/api';

const config: RequestConfig = {
  method: 'get',
  url: '/ws/api/get_route_station_details',
};

export const getRouteStationDetailsRequest = (routeId: number) =>
  createRequest({
    url: config.url,
    method: config.method,
    query: {
      id: String(routeId),
    },
  });
